<template>
    <div id="login">
        <main class="main-container">
            <!-- <div class="left_img"></div> -->
            <div class="right_text">
                <h3><span @click="toIndex"></span>欢迎登录</h3>
                <el-form :label-position="labelPosition" :model="ruleForm" label-width="110px" status-icon :rules="rules" ref="ruleForm" class="login-ruleForm">
                  <!--   <el-form-item label="企业名称：" prop="companyName">
                        <el-input type="text" v-model.trim="ruleForm.companyName" placeholder="请输入企业名称" clearable auto-complete="off"></el-input>
                    </el-form-item> -->
                    <el-form-item label="账号：" prop="account">
                        <el-input type="text" v-model.trim="ruleForm.account" placeholder="请输入账号或社会信用代码" clearable auto-complete="off"></el-input>
                    </el-form-item> 
                    <el-form-item label="密码：" prop="password">
                        <el-input type="password" v-model.trim="ruleForm.password" placeholder="请输入密码" clearable auto-complete="off"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="验证码：" prop="verificationCode" class="vericode">
                        <el-input clearable size="medium" v-model.trim="ruleForm.verificationCode" placeholder="请输入收到的验证码"></el-input>
                        <el-button @click="sendCode" size="mini" class="sendCode veriCodeImg" :loading="isSendLoading">发送验证码</el-button>
                        <span class="countDown veriCodeImg" style="display:none;">60s</span>
                    </el-form-item> -->
                    <el-form-item >
                        <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
                    </el-form-item>
                </el-form>
                <div class="other">
                    <!--<span class="forgetPass" @click="$router.push('/forget')">忘记密码</span>-->
                    <p>
                        <span class="helpCenter" @click="toHelp">帮助中心</span>
                        <span class="line"></span>
                        <span class="registerNow" @click="$router.push('/register')">立即注册</span>
                    </p>
                </div>
            </div>
        </main>
        <!-- <div class="copyright">COPYRIGHT © 赣州嘉福投资控股集团有限公司 版权所有</div> -->
    </div>
</template>
<script type="text/babel">
    import md5 from 'js-md5';
    import util from '../../util/index';
    import { loginRules } from '../../util/rules'
    export default {
        name: 'login',
        data() {
            return {
                isSendLoading: false,//是否显示loading状态，发送验证码
                labelPosition: 'left',
                imgSrc: '',//图片验证码地址；
                ruleForm: {
                    account: '',//企业名称
                    password: '',
                    /* verificationCode:'',
                    codeKey:'' */
                },
                rules: loginRules
            }
        },
        methods: {
            toIndex(){
                this.$root.activeIndex = 'home';
                this.$router.push('/');
            },
            toHelp(){
                this.$root.activeIndex = 'setting';
                this.$router.push('/help');
            },
          /*  getUuid() {
                let s = [];
                let hexDigits = "0123456789abcdef";
                for (let i = 0; i < 36; i++) {
                    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
                }
                s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
                s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
                s[8] = s[13] = s[18] = s[23] = "";

                let uuid = s.join("");
                return uuid;
            },
            getVericode(){//获取图片验证码 /rest-api/v1/login/public/restLogin
                let code = this.getUuid();
                this.imgSrc = util.baseUrl + '/v1/login/public/getGraphicCode/'+code;
                this.ruleForm.codeKey = code;
            },*/
            sendCode(){//发送验证码
                var _this = this;
                var countDownEl = document.querySelector('.countDown');
                var sendCodeEl = document.querySelector('.sendCode');
                _this.$refs.ruleForm.validateField('loginName',function(err){
                    if(!err){//如果没有错误信息，就代表手机号验证通过了，就发送验证码；
                        _this.isSendLoading = true;
                        _this.$root.getHttp(`/v1/login/public/sendSmsCode/${_this.ruleForm.loginName}`,function(res){
                            _this.isSendLoading = false;
                            countDownEl.style.display = 'block';//发送成功,显示倒计时；
                            sendCodeEl.style.display = 'none';
                            var time = setInterval(function(){
                                if(parseInt(countDownEl.innerHTML) == 1){
                                    countDownEl.innerHTML = '60S';
                                    countDownEl.style.display = 'none';
                                    sendCodeEl.style.display = 'block';
                                    clearInterval(time);
                                    return;
                                }
                                countDownEl.innerHTML = parseInt(countDownEl.innerHTML)-1 + 'S';
                            },1000);
                        },function (reject) {
                            _this.isSendLoading = false;
                        })
                    } else {
                        console.log('error')
                        _this.isSendLoading = false;
                    }
                })
            },
            passwordTips(passWordStatus){
                let _this = this;
                _this.$root.loading = true;
                _this.$root.getHttp('/v1/login/public/passwordTips/'+ window.sessionStorage.getItem('loginId'),function(res){
                    _this.$root.loading = false;
                    let msg = '';
                    if(passWordStatus==1){
                        msg = "密码已重置，为了您的账号安全请前往设置新的密码";
                    }else{
                        msg = "您还未设置账号，为了您的账号安全请前往设置新的账号和密码";
                    }
                    _this.$alert(msg, '提示', {
                        confirmButtonText: '确定',
                        type: 'success',
                        callback: action => {
                            window.sessionStorage.setItem('activeNum',1);
                            _this.$router.push('/master/basicInfo/'+999);
                        }
                    });
                },function(){
                    _this.$root.loading = false;
                })

            },
            submitForm(formName) {//提交表单
                var _this = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                       _this.$root.postHttp('/v1/login/public/restLogin',{
                           "account": _this.ruleForm.account,
                           "password": _this.ruleForm.password,
//                           "codeKey": _this.ruleForm.codeKey,
                       },function(res){
                           _this.isSendLoading = false;
                           _this.$root.isLogin = true;
//                                设置token，用来判断是否登录；
                           res.headers.token && window.sessionStorage.setItem('token',res.headers.token);
                           res.headers.refresh_token && window.sessionStorage.setItem('refresh_token',res.headers.refresh_token);
                           res.data.data.suppliersId && window.sessionStorage.setItem('loginId',res.data.data.suppliersId);
//                           res.data.data.userId && window.sessionStorage.setItem('userId',res.data.data.userId);
                           res.data.data.suppliersSplitId && window.sessionStorage.setItem('suppliersSplitIdArr',res.data.data.suppliersSplitId);
                           res.data.data.companyName && window.sessionStorage.setItem('companyName',res.data.data.companyName);
                           _this.ruleForm.loginName && window.sessionStorage.setItem('loginAccount',_this.ruleForm.loginName);
                           window.sessionStorage.setItem('isShowLog',true);
                           if(res.data.data.passWordStatus!=0){
                               _this.passwordTips(res.data.data.passWordStatus);
                           }else{
                               _this.$router.push('/master/center');
                           }
                           _this.$root.activeIndex = 'home';
                          /* 可以直接记录登录过期时的页面，直接跳转到那个页面，如果首次登录，就默认管理中心；
                          if(_this.$route.params.url == 'masterCenter'){
                               _this.$router.push('/master/center');
                           }else{
                               window.location.href = decodeURIComponent(_this.$route.params.url);
                           }*/
                       },function(){
//                           _this.sendCode();
                           _this.isSendLoading = false;
                       })
                    } else {
                        _this.$alert('请填写登录信息', '提示', {
                            confirmButtonText: '确定',
                            type: 'warning'
                        });
                        _this.isSendLoading = false;
                        return false;
                    }
                });
            }
        }
    }
</script>
<style lang="scss">
    @import "../../assets/_var.scss";

    #login {
        position: relative;
        height: 100vh;
        box-sizing: border-box;
        padding-top: 22vh;
        background: url("../../assets/images/login/bg.png") no-repeat 0 0/100% 100%;
        & main {
            width: 432px;
            overflow: hidden;
            & .left_img {
                float: left;
                width: 500px;
                height: 450px;
                background: url("../../assets/images/login/bg0.jpg") no-repeat 0 0/500px auto;
            }
            & .right_text {
                float: left;
                margin-top: 20px;
                padding: 50px 35px;
                width: 362px;
                background: #fff;
                box-shadow: 0 0 15px rgba(0,0,0,.2);
                & h3 {
                    line-height: 32px;
                    /*padding-left: 210px;*/
                    text-align: left;
                    color: $--text-color;
                    & span {
                        display: inline-block;
                        vertical-align: middle;
                        margin-right: 20px;
                        width: 130px;
                        height: 32px;
                        cursor: pointer;
                        background: url("../../assets/images/topBar1/logoIcon.png") no-repeat 0 0/240px auto;
                    }
                }
                & .el-form {
                    margin-top: 15px;
                    & .el-form-item {
                        border: 1px solid $--secondary-fill-color;
                        border-radius: 3px;
                        .el-form-item__label {
                            padding: 0 5px 0 0;
                        }
                        & .el-form-item__label::before {
                            content: '';
                            display: inline-block;
                            margin: 0 5px 0 5px;
                            vertical-align: middle;
                            width: 20px;
                            height: 20px;
                            background: url('../../assets/images/login/icon01.png') no-repeat 0 0;
                        }
                        & .el-form-item__content {
                            /*width: 210px;*/
                        }
                        & .el-input__inner {
                            border: none;
                            padding: 0;
                        }
                        & .countDown {
                         /*   position: absolute;
                            top: 4px;
                            right: 10px;*/
                            color: $--primary-color;
                            border: 1px solid $--primary-color;
                            box-sizing: border-box;
                            height: 28px;
                            display: inline-block;
                            /*padding: 0 30px;*/
                            border-radius: 3px;
                            width: 88px;
                            line-height: 28px;
                            text-align: center;
                        }
                    }
                    & .vericode .el-input__suffix {
                        right: 105px;
                    }
                    & .el-form-item:nth-of-type(2){
                        & .el-form-item__label::before {
                            background: url('../../assets/images/login/icon02.png') no-repeat 0 0;
                        }
                    }
                    & .el-form-item:nth-of-type(4){
                        & .el-form-item__label::before {
                            background: url('../../assets/images/login/icon03.png') no-repeat 0 0;
                        }
                        & .el-form-item__content {
                            position: relative;
                            & .veriCodeImg {
                                position: absolute;
                                right: 10px;
                                top: 6px;
                                cursor: pointer;
                                width: 95px;
                                height: 28px;
                            }
                        }
                    }
                    & .el-form-item:nth-of-type(3) {
                        border: none;
                        & .el-form-item__content {
                            margin-left: 0;
                            & button {
                                width: 312px;
                                margin-left: -100px;
                            }
                        }
                    }
                }
                & .other {
                    overflow: hidden;
                    font-size: 12px;
                    cursor: pointer;
                    & .forgetPass {
                        float: left;
                        color: $--primary-color;
                    }
                    & p {
                        float: right;
                        color: $--text-color-lighter;
                        & .line {
                            margin: 0 8px;
                            border-left: 1px solid $--text-color-lighter;
                        }
                    }
                }
            }
        }
        & .copyright {
           margin-top: 50px;
            font-size: 12px;
            color: $--text-color-lighter;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/common/Login.vue